<template>
    <div class="free-table">
        <div class="nocolumns" v-if="!columns || columns.length == 0" style="color:#fd349c;">This table doesn't have table header, this is a data error.</div>
        <el-table class="table" :data="hereValue" border v-else>
            <el-table-column
                v-for="(thv, thk) in columns" 
                :key="thk" 
                :label="thv.text" 
                align="center"
                header-align="center">
                <span slot-scope="scope" v-if="disableEdit">{{ findTdContent(scope.row, thk) }} <br/> {{ findTdOthersContent(scope.row, thk) }}</span>
                <el-input
                    v-else-if="!disableEdit && !thv.options"
                    class="td-input"
                    slot-scope="scope"
                    :value="findTdContent(scope.row, thk)"
                    @input="e => tdChange(scope.row, thk, e)"
                    :placeholder="$t('freetable_input_placeholder', {key: thv.text})"
                ></el-input>
                <div v-else>
                    <el-select
                        @change="e => tdChange(scope.row, thk, e)"
                        :value="findTdContent(scope.row, thk)"
                        :placeholder="$t('freetable_select_placeholder', {key: thv.text})"
                        clearable>
                        <el-option
                            v-for="(v, k) in thv.options"
                            :key="k"
                            :value="v"
                            :label="v"
                        ></el-option>
                    </el-select>
                    <el-input
                        v-if="['其他', 'others'].includes(findTdContent(scope.row, thk))"
                        :value="findTdOthersContent(scope.row, thk)"
                        @input="e => tdOthersChange(scope.row, thk, e)"
                        :placeholder="$t('freetable_input_others_placeholder', {key: thv.text})"
                    ></el-input>
                    <!-- <el-input
                        v-show="['其他', 'others'].includes(findTdContent(scope.row, thk))"
                        class="td-input"
                        slot-scope="scope"
                        :value="findTdOthersContent(scope.row, thk)"
                        @input="e => tdOthersChange(scope.row, thk, e)"
                        :placeholder="$t('freetable_input_placeholder', {key: thv.text})"
                    ></el-input> -->
                </div>
            </el-table-column>
            <el-table-column width="80" align="center" header-align="center" v-if="getUser.userType == '2' && !disableEdit">
                <span style="color:#fd349c; cursor: pointer;" slot-scope="{$index}" @click="onRowDeleteClick($index)">{{ $t('COMMON_DELETE') }}</span>
            </el-table-column>
        </el-table>
        <div class="addmore" @click="onAddMoreClick" v-if="!disableEdit">
            <img :src="AddIcon" class="add-icon">
            <div class="add-text">{{ $t('freetable_add_more') }}</div>
        </div>
    </div>
</template>
<script>
import AddIcon from '@/assets/img/icon-add.svg'
import { mapGetters } from "vuex"

export default {
    name: 'FreeTable',
    data() {return {
        AddIcon,
        hereValue: []
    }},
    props: {
        value: {
            type: Array,
            default: () => []
        },
        columns: {
            type: Array,
            default: () => []
        },
        onChange: {
            type: Function,
            default: () => {}
        },
        disableEdit: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.hereValue = this.value
    },
    methods: {
        onRowDeleteClick(index) {
            this.hereValue.splice(index, 1 )
        },
        onAddMoreClick() {
            let newv = {}
            this.columns.forEach((v, k) => {
                newv['col_' + k] = ''
                newv['col_others_' + k] = ''
            })
            if (!this.hereValue) {
                this.hereValue = []
            }
            this.hereValue.push(newv)

            this.onChange && this.onChange(this.hereValue)
        },
        findTdContent(v, key) {
            return v && v['col_' + key] ? v['col_' + key] : ''
        },
        findTdOthersContent(v, key) {
            return v && v['col_others_' + key] ? v['col_others_' + key] : ''
        },
        tdChange(row, k, e) {
             
            row['col_' + k] = e
            if (e == '其他' || e == 'others') {
                row['col_others_' + k] = ''
            }
            this.onChange && this.onChange(this.hereValue)
        },
        tdOthersChange(row, k, e) {
             
            row['col_others_' + k] = e
            this.onChange && this.onChange(this.hereValue)
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser',
            getEntityIds: 'getEntityIds',
        }),
    },
    watch: {
        // hereValue(v) {
        //     // this.$emit('update:value', v)
        //     this.onChange && this.onChange(v)
        // },
        // value(v) {
        //     this.hereValue = v
        // }
    }
}
</script>
<style scoped>
.free-table {
    width: 60%;
    display: flex;
    flex-direction: column;
}
.free-table .table {
    
}
.td-input ::v-deep input {
    border: none;
    text-align: center;
}
::v-deep .el-table .el-table__header tr:nth-child(1) th {
    border-top: none;
}
.free-table .addmore {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #4682ec;
    margin-top: 20px;
    cursor: pointer;
}
.free-table .addmore .add-icon {
    width: 20px;
    height: 20px;
}
.free-table .addmore .add-text {
    font-size: 13px;
    margin-left: 10px;
}
</style>